import React, { useState, useEffect } from "react";

import CheckIcon from "../../icons/check";
import ArrowBack from "../../icons/arrow_back";
import { CodeBlock, monokai } from "react-code-blocks";
import beautify from 'json-beautify';
import LoadingIcon from "../../icons/loading";
import ErrorIcon from "../../icons/error";
import CopyIcon from "../../icons/copy";

import axios from "axios";
import { apiUrl } from "../../config/api";

function SandboxStandard(props) {

    const [params, setParams] = useState([]);
    const [paramsLoad, setParamsLoad] = useState(true);

    const [requestParams, setrequestParams] = useState({});
    const [rightsCheck, setRightsCheck] = useState(false);
    const [requestError, setRequestError] = useState("check");
    const [requestLoading, setRequestLoading] = useState(false);
    const [selectedEndpoint, setSelectedEndpoint] = useState({});
    const [resultApiLogId, setResultApiLogId] = useState("");

    const [selectedLog, setSelectedLog] = useState({});
    const [selectedLogLoad, setSelectedLogLoad] = useState(true);
    const [responseCopied, setResponseCopied] = useState(false);

    const hasValue = (value) => {
        return value !== undefined && value !== null && String(value).trim().length > 0;
    }

    const hasDocumentAlternativeRule = () => {
        const paramNames = params.map(param => param.Name);
        return paramNames.includes("document") && paramNames.includes("documentNumber");
    }

    const getParams = (endpoint) => {
        props.setSelectedApi(endpoint)
        console.log(endpoint);
        setSelectedEndpoint(endpoint);
        setParamsLoad(true);
        setrequestParams({});
        setRightsCheck(false);
        setRequestError("");
        setResultApiLogId("");
    
        try {
          axios.post(
            apiUrl("/marketplace/sandbox/params"),
            { endpointId: endpoint.EndPointId }
          )
            .then((res) => {
                console.log(res.data);
                res.data.map( param => {
                    if (param.Description == "application/json") {
                        setrequestParams(prevState => ({
                            ...prevState,
                            [param.Name]: "application/json"
                        }));
                    } else if (param.Required) {
                        setrequestParams(prevState => ({
                            ...prevState,
                            [param.Name]: ""
                        }));
                    }
                });
              setParams(res.data)
              setParamsLoad(false)
            })
    
        } catch (error) {
        }
    }

    const sendRequest = async () => {
        setRequestError("");
        setResultApiLogId("");
        setResponseCopied(false);

        if (rightsCheck) {
            
            let paramsArray = []

            Object.keys(requestParams).map(key => {
                paramsArray.push({"name": key, "value": requestParams[key]})
            });

            const documentAlternative = hasDocumentAlternativeRule();
            const requiredMissing = params
                .filter(param => param.Required)
                .map(param => param.Name)
                .filter(param => !(documentAlternative && ["document", "documentNumber"].includes(param)))
                .some(param => !hasValue(requestParams[param]));

            if (
                documentAlternative &&
                !hasValue(requestParams.document) &&
                !hasValue(requestParams.documentNumber)
            ) {
                setRequestError("documentAlternative");
            } else if (requiredMissing) {
                setRequestError("fields");
            } else {
                const requestBody = {
                    clientId: props.clientId,
                    endpointId: selectedEndpoint.EndPointId,
                    params: paramsArray
                };       
                setRequestLoading(true);
                setRequestError("");
                try {
                    const res = await axios.post(
                        apiUrl("/sandbox/send-request"),
                        requestBody
                    );

                    if (res.data.err) {
                        if (res.data.err == "Out of balance") {
                            setRequestError("balance");
                        } else {
                            setRequestError("try");
                            console.log(res.data);
                        }
                    } else if(res.data) {
                        console.log(res.data);
                        setResultApiLogId(res.data)
                        loadLog(res.data);
                        setRightsCheck("");
                        props.reduceCall(selectedEndpoint.ApiId);
                    }
                } catch (error) {
                    console.log(error);
                    setRequestError("error");
                } finally {
                    setRequestLoading(false);
                }    
            }
                        
        } else {
            setRequestError("checkbox");
        }
    }

    const handleChange = (name, value) => {
        setrequestParams(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const loadLog = ( apiLogId ) => {
        setSelectedLog({});
        setSelectedLogLoad(true);
        try {
      
            const getLogDetails = {
              clientId: props.clientId,
              apiLogId: apiLogId
            }
      
          axios.post(
            apiUrl("/marketplace/api/logs/details"),
            getLogDetails
          )
          .then(res => {
            console.log(res.data[0]);
            setSelectedLog(res.data[0]);
            setSelectedLogLoad(false);
          })
        } catch (error) {}  
      }
      

      const formatDateTime = (dateTimeString) => {
        const date = new Date(dateTimeString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
      
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      }
      const formatJson = (jsonString) => {
        try {
          const parsedJson = JSON.parse(jsonString);
          const formattedJson = beautify(parsedJson, null, 2, 80);
          return formattedJson;
        } catch (error) {
          return jsonString;
        }
      }

      const parseLogJson = (jsonString, fallback) => {
        try {
          return JSON.parse(jsonString);
        } catch (error) {
          return fallback;
        }
      }

      const getLogRequestParams = () => {
        const parsedRequest = parseLogJson(selectedLog.JsonRequest, []);
        if (Array.isArray(parsedRequest)) {
          return parsedRequest;
        }
        if (Array.isArray(parsedRequest.params)) {
          return parsedRequest.params;
        }
        if (parsedRequest.body && typeof parsedRequest.body === "object") {
          return Object.keys(parsedRequest.body).map(key => ({
            name: key,
            value: parsedRequest.body[key]
          }));
        }
        return [];
      }

      const isSuccessfulLog = (status) => {
        return ["SUCCESS", "200 OK", "200", 200].includes(status);
      }

      const copyResponseJson = async () => {
        const responseText = formatJson(selectedLog.JsonResponse || "");
        try {
          await navigator.clipboard.writeText(responseText);
          setResponseCopied(true);
          setTimeout(() => setResponseCopied(false), 1600);
        } catch (error) {
          console.log(error);
        }
      }

    return (
        <div className="flex_content" id="flex_sandbox">
            <div className="flex_right_side">
                {
                    !props.apiListLoad
                    ?
                    Object.keys(props.apiList).map(apiId => (
                        <>
                            <div className="sandbox_api_list_title">
                                <h2>{props.apiList[apiId][0].ApiName}</h2>
                                <span>{props.apiList[apiId][0].NumberCall} Calls</span>
                            </div>
                            <a href="#flex_sandbox" className="sandbox_api_list_endpoint_flex">
                            { props.apiList[apiId].map(endpoint => (
                                <div className="sandbox_api_list_endpoint" onClick={() => getParams(endpoint)}>
                                    <div className="endpoint_icon"></div>
                                    <h3>{endpoint.Name}</h3>
                                </div>
                            )) }
                            </a>
                        </>
                    ))
                    :
                    <p>loading</p>
                }
            </div>
            <div className="flex_left_side sandbox_api_list_endpoint_action">



                {
                resultApiLogId ?
                    <>
                    <div className="btn btn_primary btn_outline" onClick={() => setResultApiLogId("")}>
                        <ArrowBack />
                        <span>{props.lang == "english" ? "Send another request" : "Enviar otra solicitud"}</span>                        
                    </div>
                    <h6 className="api_log_subtite">{props.lang == "english" ? "Request Id" : "ID de la Petición"}</h6>
                    <h1 className="api_log_title">{resultApiLogId}</h1>
                    <div className="api_log_details">
                    <div className="api_log_detail">
                        <span>{props.lang == "english" ? "API ID" : "ID de la API"}</span>
                        <span className="api_log_detail_value">{selectedEndpoint.ApiId}</span>
                    </div>
                    <div className="api_log_detail">
                        <span>{props.lang == "english" ? "API title" : "Título de la API"}</span>
                        <span className="api_log_detail_value">{selectedEndpoint.ApiName}</span>
                    </div>
                    <div className="api_log_detail">
                        <span>{props.lang == "english" ? "Endpoint ID" : "ID del Endpoint"}</span>
                        <span className="api_log_detail_value">{selectedEndpoint.EndPointId}</span>
                    </div>
                    <div className="api_log_detail">
                        <span>{props.lang == "english" ? "Endpoint title" : "Título del Endpoint"}</span>
                        <span className="api_log_detail_value">{selectedEndpoint.Name}</span>
                    </div>


                    {
                        selectedLogLoad
                        ?
                        <>
                        <div className="api_log_detail api_log_detail_skeleton">
                            <span>{props.lang == "english" ? "Status" : "Estado"}</span>
                            <span className="api_log_status"></span>
                        </div>
                        <div className="api_log_detail api_log_detail_skeleton">
                            <span>{props.lang == "english" ? "Date and time" : "Fecha y hora"}</span>
                            <span className="api_log_detail_value"></span>
                        </div>
                        <div className="api_log_detail api_log_detail_skeleton">
                            <span>{props.lang == "english" ? "Duration" : "Duración"}</span>
                            <span className="api_log_detail_value"></span>
                        </div>
                        <div className="api_log_detail api_log_detail_vert api_log_detail_skeleton">
                            <span>{props.lang == "english" ? "Request Body" : "Cuerpo de la Petición"}</span>
                            <div className="api_log_param">
                                <div className="api_log_detail">
                                    <span className="api_log_deatil_name"></span>
                                    <span className="api_log_detail_value"></span>
                                </div>
                                <div className="api_log_detail">
                                    <span className="api_log_deatil_name"></span>
                                    <span className="api_log_detail_value"></span>
                                </div>
                            </div>
                        </div>
                        <div className="api_log_detail api_log_detail_vert api_log_detail_skeleton">
                            <span>{props.lang == "english" ? "Request Response" : "Respuesta de la Petición"}</span>
                            <div className="api_code api_code_skeleton"></div>
                        </div>
                        </>
                        :
                        <>
                                <div className="api_log_detail">
                                    <span>{props.lang == "english" ? "Status" : "Estado"}</span>
                                    <span className={isSuccessfulLog(selectedLog.Status) ? "api_log_status" : "api_log_status api_log_status_err"}>{selectedLog.Status}</span>
                                </div>
                                <div className="api_log_detail">
                                    <span>{props.lang == "english" ? "Date and time" : "Fecha y hora"}</span>
                                    <span className="api_log_detail_value">{formatDateTime(selectedLog.CreationDate)}</span>
                                </div>
                                <div className="api_log_detail">
                                    <span>{props.lang == "english" ? "Duration" : "Duración"}</span>
                                    <span className="api_log_detail_value">{selectedLog.Latency} ms</span>
                                </div>
                                <div className="api_log_detail api_log_detail_vert">
                                    <span>{props.lang == "english" ? "Request Body" : "Cuerpo de la Petición"}</span>
                                    <div className="api_log_param">
                                        {
                                            getLogRequestParams().map(req =>
                                            <div className="api_log_detail">
                                                <span>{req.name}</span>
                                                <span className="api_log_detail_value">{typeof req.value === "object" ? JSON.stringify(req.value) : req.value}</span>
                                            </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="api_log_detail api_log_detail_vert api_log_response_detail">
                                    <div className="api_log_response_header">
                                        <span>{props.lang == "english" ? "Request Response" : "Respuesta de la Petición"}</span>
                                        <button type="button" className="api_log_copy_btn" onClick={copyResponseJson}>
                                            <CopyIcon />
                                            <span>{responseCopied ? (props.lang == "english" ? "Copied" : "Copiado") : (props.lang == "english" ? "Copy JSON" : "Copiar JSON")}</span>
                                        </button>
                                    </div>
                                    <div className="api_code">
                        <div className="api_code_background">
                            <CodeBlock
                            text={formatJson(selectedLog.JsonResponse)}
                            language='json'
                            showLineNumbers={true}
                            theme={monokai}
                            wrapLines={true}
                            
                            showInlineLineNumbers={false}
                            wrapLongLines={true}
                            lineProps={{ style: { flexWrap: 'wrap' } }}
                            />
                        </div>
                        </div>
                                </div>
                        </>
                    }
                    </div>
                        </>
                        :
                        <>
                        
                        {
                    props.selectedApi.empty
                    ?
                    <></>
                    :
                    paramsLoad
                    ?
                    <p>Loading</p>
                    :
                    <>
                        <h2>{props.selectedApi.Name}</h2>
                        <p>{props.selectedApi.Description}</p>
                        {
                            hasDocumentAlternativeRule() &&
                            <p className="sandbox_param_note">
                                {props.lang == "english" ? "Send documentNumber or document. At least one is required." : "Envía documentNumber o document. Al menos uno es obligatorio."}
                            </p>
                        }
                        <div className="sandbox_api_list_endpoint_params">
                            {
                                params?.map(param => (
                                    <div className="input_container">
                                        <div className="input_label_flex">
                                            <label>{param.Name}</label>
                                            <span className={param.Required ? "active" : "" }>
                                                {param.Required ? "Required" : "Optional" }
                                            </span>
                                        </div>
                                        <input type="text" onChange={(e) => handleChange(param.Name, e.target.value)} />
                                    </div>
                                ))
                            }
                            <div className={"input_checkbox_container" + (rightsCheck ? " active" : "")} onClick={() => setRightsCheck(!rightsCheck)}>
                                <div className="input_radio">
                                    { rightsCheck && <CheckIcon /> }
                                </div>
                                <span>{props.lang == "english" ? "I declare that I have the necessary authorization." : "Declaro que cuento con la autorización necesaria"}</span>
                            </div>           
                        </div>
                        {
                            (requestError == "checkbox") &&
                            <div className="btn btn_indicator btn_primary btn_error">
                                <ErrorIcon />
                                <span>{props.lang == "english" ? "You must check the authorization box.": "Debe marcar la casilla de autorización"}</span>
                            </div>
                        }
                        {/* Debe marcar la casilla para confirmar que tiene la autorización necesaria. */}
                        {
                            (requestError == "params") &&
                            <div className="btn btn_indicator btn_primary btn_error">
                                <ErrorIcon />
                                <span>{props.lang == "english" ? "Please fill all required fields." : "Por favor, rellene todos los campos obligatorios."}</span>
                            </div>
                        }
                        {
                            (requestError == "fields") &&
                            <div className="btn btn_indicator btn_primary btn_error">
                                <ErrorIcon />
                                <span>{props.lang == "english" ? "Fill required fields." : "Complete los campos obligatorios."}</span>
                            </div>
                        }
                        {
                            (requestError == "documentAlternative") &&
                            <div className="btn btn_indicator btn_primary btn_error">
                                <ErrorIcon />
                                <span>{props.lang == "english" ? "Send documentNumber or document." : "Envía documentNumber o document."}</span>
                            </div>
                        }
                        {
                            (requestError == "balance") &&
                            <div className="btn btn_indicator btn_primary btn_error">
                                <ErrorIcon />
                                <span>{props.lang == "english" ? "You are out of balance." : "No tienes saldo."}</span>
                            </div>
                        }
                        {
                            (requestError == "error" || requestError == "try") &&
                            <div className="btn btn_indicator btn_primary btn_error">
                                <ErrorIcon />
                                <span>{props.lang == "english" ? "An error occurred. Please try again later." : "Se ha producido un error. Vuelva a intentarlo más tarde."}</span>
                            </div>
                        }
                        <div className="sandbox_api_list_endpoint_submit">
                            {
                                requestLoading &&
                                <div className="btn btn_icon btn_indicator btn_primary btn_loading">
                                    <LoadingIcon />
                                </div>
                            }
                            <div
                                className={"btn btn_primary" + (requestLoading ? " btn_loading" : "")}
                                onClick={() => !requestLoading ? sendRequest() : null}
                            >
                                <span>Send request</span>
                            </div>
                        </div>
                    </>
                }
                        
                        </>
                }


            </div>
        </div>
    );
}

export default SandboxStandard;
